import { render, staticRenderFns } from "./WishListContainer.vue?vue&type=template&id=bbe4cd76"
import script from "./WishListContainer.ts?vue&type=script&lang=ts&external"
export * from "./WishListContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports